import { render, staticRenderFns } from "./BatchOperateDeletaShop.vue?vue&type=template&id=bac66bbc&scoped=true"
import script from "./BatchOperateDeletaShop.vue?vue&type=script&lang=ts"
export * from "./BatchOperateDeletaShop.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateDeletaShop.vue?vue&type=style&index=0&id=bac66bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac66bbc",
  null
  
)

export default component.exports